module.exports = __webpack_public_path__ + "static/media/TRIAL 3-unanswered-after-10-sec.c24968b6.mp3";